import React, { useEffect, useState } from "react";
import curveLine from "../assets/curveLine.png";
import about_us from "../assets/about_us.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
function AboutUs() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, [])
  return (
    <div
      id="about"
      className="w-full flex flex-col-reverse md:flex-row items-center justify-center bg-[#EBEBEB|] bg-white  md:py-28"
    >
      <div data-aos="fade-right"  className="py-16 sm:py-0 w-[90%] sm:w-[80%] md:w-[60%] lg:w-1/2 md:pl-10 md:pr-14">
        <div className="text-themeColor text-3xl sm:text-4xl font-yeseva pb-1">
          About Us
        </div>
        <div className="text-[#0B0B19] text-3xl sm:text-4xl font-sans font-semibold py-1">
          The First and Only Parent/ Guardian-Led Marriage App
        </div>
        <img className="py-5" src={curveLine} alt="" />
        <div className="text-justify font-poppins text-[12px] sm:text-sm">
        At My Wali, we understand the importance of upholding Islamic values and traditions in the pursuit of matrimony. Our platform is designed to provide marriage introductions that fully comply with Islamic principles. Whether it’s a guardian-led search or a seeker taking the lead with support of their guardian, My Wali offers a trusted environment to find the perfect match. Each seeker profile on our app is associated with a registered and verified guardian, who is actively involved throughout the entire process.
        </div>
        <div className="text-justify font-poppins text-[12px] sm:text-sm pt-10">
        My Wali was born out of personal struggles of our founders, who were determined to find the most halal and suitable matches for their children. They discovered that existing apps either didn't align with Islamic values or failed to provide the parental involvement necessary for such an important decision. They realised that whilst they wanted to ensure their children's marriages were rooted in Islamic values, it was challenging to connect with like-minded families who shared the same priorities. This experience led to the creation of My Wali- a platform where parents and guardians can easily find each other, all while ensuring every match is made with faith, trust, and guidance at the centre. My Wali is more than an app; it’s a community dedicated to helping families find the right companion for their children.
        </div>
      </div>

      <div data-aos="fade-left"  className="w-[80%] sm:w-[40%] ">
        <div className=" pt-10 md:pt-0 w-full flex justify-center items-center sm:pr-5 pb-5 md:pb-0">
          <img className="" src={about_us} alt="" />
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
